import "./Button.css"
import { ReactNode } from 'react'

export type ButtonProps = {
    className: string
    children: ReactNode
}

export const Button = (props: ButtonProps) => {
    return (
        <button className={props.className}>
            {props.children}
        </button>
    )
}